import { useState, useEffect, useCallback } from "react";
import employeeService from "Services/AdminServices/EmployeeService";

function jobService() {
  const [jobFormData, setJobFormData] = useState({
    hiringDate: "",
    probationStartDate: "",
    probationEndDate: "",
    designationId: 0,
    baseSalary: "", 
    priorExperience:"",   // decimal value
    departmentId: 0,   // Add departmentId with default value
  });

  const [jobFormDataError, setJobFormDataError] = useState({
    hiringDateError: "",
    probationStartDateError: "",
    probationEndDateError: "",
    designationIdError: "",
    baseSalaryError: "",
    priorExperienceError:"",
  });

  const [designations, setDesignations] = useState([]);

  // Fetch Management & IndiCont Designations on component mount
  useEffect(() => {
    async function fetchDesignations() {
      try {
        const res = await employeeService.getDesignationsByLevels(1,2); 
        console.log("desonatons", res);
        setDesignations(res || []);
      } catch (err) {
        console.error("Error fetching designations", err);
      }
    }
    fetchDesignations();
  }, []);

const handleJobChange = useCallback(
  (e) => {
    const { name, value } = e.target;
    let newValue = value;

    // Convert numeric fields
    if (name === "designationId" || name === "baseSalary" || name === "priorExperience") {
      newValue = Number(value);
    }

    // Probation validations
    if (name === "probationStartDate") {
      if (jobFormData.hiringDate && new Date(value) < new Date(jobFormData.hiringDate)) {
        setJobFormDataError((prev) => ({
          ...prev,
          probationStartDateError: "Probation start cannot be before hiring date",
        }));
        return;
      }
    }

    if (name === "probationEndDate") {
      if (jobFormData.probationStartDate && new Date(value) <= new Date(jobFormData.probationStartDate)) {
        setJobFormDataError((prev) => ({
          ...prev,
          probationEndDateError: "Probation end must be after probation start",
        }));
        return;
      }
    }

    // Clear previous error for this field
    setJobFormDataError((prev) => ({ ...prev, [`${name}Error`]: "" }));

    setJobFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  },
  [jobFormData.hiringDate, jobFormData.probationStartDate]
);

  const validateStep2 = useCallback(() => {
    let valid = true;
    const errors = {};
    
    if (!jobFormData.hiringDate) { 
      errors.hiringDateError = "Hiring Date is required"; 
      valid = false; 
    }
    if (!jobFormData.probationStartDate) { 
      errors.probationStartDateError = "Probation Start Date is required"; 
      valid = false; 
    }
    if (!jobFormData.probationEndDate) { 
      errors.probationEndDateError = "Probation End Date is required"; 
      valid = false; 
    }
    if (!jobFormData.designationId) { 
      errors.designationIdError = "Designation is required"; 
      valid = false; 
    }
    
    if (!jobFormData.baseSalary || jobFormData.baseSalary <= 0) { 
      errors.baseSalaryError = "A valid Base Salary is required"; 
      valid = false; 
    }

    if (!jobFormData.priorExperience || jobFormData.priorExperience < 0) {
  errors.priorExperienceError = "A valid Prior Experience is required";
  valid = false;
}

    setJobFormDataError(errors);
    return valid;
  }, [jobFormData]);

  // The component will handle the actual "next" action.
  return {
    jobFormData,
    setJobFormData,
    jobFormDataError,
    handleJobChange,
    validateStep2,
    designations,
  };
}

export default jobService;